import { observer } from "mobx-react-lite";
import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { useStore } from "src/stores";
import { StreamProvider } from "./Stream";
import { Thread } from "./Thread";
import { useChatDeviceContext } from "./useChatDeviceContext";

export const ChatUI = observer(function ChatUI({
  onClose,
  setMaxWidth,
}: {
  onClose?: () => void;
  setMaxWidth?: boolean;
}) {
  const { agentStore } = useStore();
  const { orgId } = useChatDeviceContext();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    // Only clear thread data if orgId changed and there's no agentThreadId in the URL
    // This preserves thread data when opening a URL with a specific agent thread.
    if (!searchParams.get("agentThreadId")) {
      agentStore.clearThreadData();
    }
  }, [orgId]);

  return (
    <StreamProvider>
      <Thread onClose={onClose} setMaxWidth={setMaxWidth} />
    </StreamProvider>
  );
});
